// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__270CF","rootMobile":"styles_rootMobile__wgb1w"};